import MultiSelectProTipBanner from "@src/features/contentDetail/shared/MultiSelectProTipBanner";
import Spacer from "@src/lib/ui/Spacer";
import { Button } from "@src/lib/ui/Button";
import { Dialog, DialogContent } from "@src/lib/ui/Dialog";
import Text from "@src/lib/ui/Text";
import { pluralize } from "@src/lib/utils/strings";
import { FC } from "react";
import ThumbsUpOutlineIcon from "@src/lib/icons/18px/thumbs-up-outline";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  numberOfResourcesUploaded: number;
};

const TrainingResourceBulkUploadConfirmationDialog: FC<Props> = ({
  open,
  onOpenChange,
  numberOfResourcesUploaded,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hideCloseButton className="w-auto max-w-none p-6 pb-8">
        <div className="flex flex-col items-center">
          <div className="flex size-14 items-center justify-center rounded-lg bg-green-2">
            <ThumbsUpOutlineIcon className="size-8" />
          </div>
          <Spacer size={32} />
          <Text variant="body-title">
            {numberOfResourcesUploaded}{" "}
            {pluralize("Resource", numberOfResourcesUploaded)} have been added
            to your library
          </Text>
          <Spacer size={4} />
          <MultiSelectProTipBanner />
          <Spacer size={48} />
          <Button
            className="border-gray-13 bg-gray-13 text-white hover:border-gray-12 hover:bg-gray-12"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TrainingResourceBulkUploadConfirmationDialog;
